<template>
  <div class="form-block-wrapper">
    <div class="cushion-info-wrapper mb-5">
      <p class="font-semibold text-lg lg:text-2xl mb-5">
        {{ $t('Your cushion') }} <span class="text-gray">{{ $t(name) }}</span>
      </p>
      <div class="cushion-info space-y-2">
        <div class="info-item">
          <span class="left-title">{{ $t('Form') }}</span>
          <span class="right-value">{{ $t(getMagentoFieldName(shape)) }}</span>
        </div>
        <div class="info-item">
          <span class="left-title">{{ $t('Type') }}</span>
          <span class="right-value">{{ $t(getMagentoFieldName(cushion)) }}</span>
        </div>
        <div class="info-item">
          <span class="left-title">{{ $t('Edge Sewing') }}</span>
          <span class="right-value">{{ $t(getMagentoFieldName(edgeSewing)) }}</span>
        </div>
        <div class="info-item">
          <span class="left-title">{{ $t('Material on top, sides & possibly buttons') }}</span>
          <span class="right-value">{{ fabrics.data.name }}</span>
        </div>
        <div class="info-item">
          <span class="left-title">{{ $t('Material on the underside') }}</span
          ><span class="right-value">{{ $t(getMagentoFieldName(cushionBottom)) }}</span>
        </div>
        <div v-if="isStitches === 'stitches_yes' && crossTopSewing != ''" class="info-item">
          <span class="left-title">{{ $t('Cross Top Sewing') }}</span>
          <span class="right-value">{{ $t(getMagentoFieldName(crossTopSewing)) }}</span>
        </div>
        <div class="info-item" v-if="width_a_rectangle">
          <span class="left-title">{{ $t('Width') }}</span>
          <span class="right-value">{{ $t(width_a_rectangle) }} cm</span>
        </div>
        <div class="info-item" v-if="length_b_rectangle">
          <span class="left-title">{{ $t('Length') }}</span>
          <span class="right-value">{{ $t(length_b_rectangle) }} cm</span>
        </div>
        <div class="info-item" v-if="diameter_a_circle">
          <span class="left-title">{{ $t('Diameter') }}</span>
          <span class="right-value">{{ $t(diameter_a_circle) }} cm</span>
        </div>
        <div v-if="thickness" class="info-item">
          <span class="left-title">{{ $t('Thickness') }}</span>
          <span class="right-value">{{ $t(String(thickness)) }} cm</span>
        </div>
        <div class="info-item">
          <span class="left-title">{{ $t('Buttons') }}</span>
          <span v-if="isButtons === 'buttons_no'" class="right-value">{{ $t('No') }}</span>
          <span v-if="isButtons === 'buttons_yes'" class="right-value">
            {{ $t('Yes') }}

            <span
              v-if="
                isButtons === 'buttons_yes' && Number(buttonsRows) > 0 && Number(buttonsCols) > 0
              "
              class="right-value"
            >
              ({{ $t(buttonsRows) }}/{{ $t(buttonsCols) }})
            </span>
          </span>
        </div>
        <div v-if="isButtons === 'buttons_yes' && buttonsDistribution != ''" class="info-item">
          <span class="left-title">{{ $t('Buttons distribution') }}</span
          ><span class="right-value">{{ $t(getMagentoFieldName(buttonsDistribution)) }}</span>
        </div>
        <div v-if="isStitches === 'stitches_yes' && stitchesDistribution != ''" class="info-item">
          <span class="left-title">{{ $t('Stitches distribution') }}</span
          ><span class="right-value">{{ $t(getMagentoFieldName(stitchesDistribution)) }}</span>
        </div>
        <div v-if="isStitches === 'stitches_yes' && topStitchesType != ''" class="info-item">
          <span class="left-title">{{ $t('Top sewings type') }}</span
          ><span class="right-value">{{ $t(getMagentoFieldName(topStitchesType)) }}</span>
        </div>
        <div
          v-if="isButtons === 'buttons_yes' && Number(buttonsDistanceToEdge) > 0"
          class="info-item"
        >
          <span class="left-title">{{ $t('Buttons distance to edge') }}</span>
          <span class="right-value">{{ $t(buttonsDistanceToEdge) }} cm</span>
        </div>
        <div
          v-if="isStitches === 'stitches_yes' && Number(stitchesDistanceToEdge) > 0"
          class="info-item"
        >
          <span class="left-title">{{ $t('Stitches distance to edge') }}</span>
          <span class="right-value">{{ $t(stitchesDistanceToEdge) }}</span>
        </div>
        <div v-if="isButtonMiddle !== ''" class="info-item">
          <span class="left-title">{{ $t('Button in the middle') }}</span
          ><span class="right-value">{{ $t(getMagentoFieldName(isButtonMiddle)) }}</span>
        </div>
        <div class="info-item">
          <span class="left-title">{{ $t('Top sewings') }}</span
          ><span class="right-value">{{ $t(getMagentoFieldName(isStitches)) }}</span>
        </div>
        <div
          v-if="
            isStitches === 'stitches_yes' &&
            isButtons === 'buttons_no' &&
            Number(stitchesRows) > 0 &&
            Number(stitchesCols) > 0
          "
        >
          <div class="info-item">
            <span class="left-title">{{ $t('Rows of sewings') }}</span
            ><span class="right-value">{{ $t(stitchesRows) }}</span>
          </div>
          <div class="info-item">
            <span class="left-title">{{ $t('Stitches cols') }}</span
            ><span class="right-value">{{ $t(stitchesCols) }}</span>
          </div>
        </div>
      </div>
    </div>
    <div class="form-wrapper">
      <div class="price-value-wrapper summary space-y-4 mb-10">
        <div class="price-block grid grid-cols-2">
          <span class="vat-price-text text-black/60 text-lg">{{ $t('Subtotal') }}</span>
          <span class="price-value text-2xl text-center font-semibold">{{ priceWithoutVat }}</span>
        </div>
        <div class="price-block grid grid-cols-2">
          <span class="vat-price-text text-black/60 text-lg">{{ $t('VAT is 25%') }}</span>
          <span class="price-value text-2xl text-center font-semibold">{{ taxAmount }} </span>
        </div>
        <div v-if="shippingCost !== null" class="price-block grid grid-cols-2">
          <span class="vat-price-text text-black/60 text-lg">{{ $t('Shipping') }}</span>
          <span class="price-value text-2xl text-center font-semibold">{{ shippingCost }} </span>
        </div>
        <div class="price-block grid grid-cols-2">
          <span class="vat-price-text text-black/60 text-lg">{{ $t('Grand total') }}</span>
          <span class="price-value text-2xl text-center font-semibold">{{ grandTotal }}</span>
        </div>
      </div>
      <div class="add-to-cart-group flex gap-2">
        <button class="btn btn-primary" type="button" @click="() => (store.currentStep = 3)">
          <IconArrowLeft />
          {{ $t('Back') }}
        </button>
        <button
          v-if="!updateState"
          id="addToCart"
          type="button"
          :class="{ active: changeAddToCartStyle }"
          :disabled="changeAddToCartStyle || loading"
          class="btn btn-primary add-to-cart-btn"
          @click="addToCart"
        >
          <span v-show="!loading">{{ $t('Add to cart') }}</span>
          <span v-show="loading">{{ $t('Loading') }}</span>
          <div v-show="loading" class="loading"></div>
        </button>

        <button v-if="updateState" type="button" class="btn add-to-cart-btn" @click="updateCart">
          {{ $t('UPDATE CART') }}
        </button>
      </div>
      <div class="flex gap-2 mt-4 form-group quantity-group">
        <button
          v-on:click="store.changeQuantity(quantity - 1)"
          :disabled="changeAddToCartStyle"
          v-bind:class="{ disabled: quantity <= 1, active: changeAddToCartStyle }"
          class="minus btn btn-primary"
        >
          -
        </button>
        <input
          v-model.number="quantity"
          name="quantity"
          class="field-input !p-1 !w-20 text-center form-control quantity"
          type="text"
          inputmode="numeric"
        />

        <button
          v-on:click="store.changeQuantity(quantity + 1)"
          :disabled="changeAddToCartStyle"
          class="plus btn btn-primary"
          v-bind:class="{ active: changeAddToCartStyle }"
        >
          +
        </button>
      </div>
    </div>
    <div v-if="showAddToCartMessage" class="add-to-cart-tip-wrapper">
      <div class="text-part">
        <p class="tip-message">
          {{ $t('This cushion has been added to your cart') }}
        </p>
      </div>
    </div>
    <div v-if="addProceedToCheckout" class="mt-4">
      <button
        type="button"
        class="btn btn-primary design-another-cushion"
        data-action="close"
        data-bind="
            attr: {
                title: $t('Proceed to Checkout')
            }
        "
        @click="processCheckoutClick()"
      >
        {{ $t('PROCEED TO CHECKOUT') }}
      </button>
      <div data-bind="html: getCartParam('extra_actions')"></div>
    </div>
    <!--
        <div class="form-group">
            <button type="button" class="btn design-another-cushion" v-on:click="designAnotherCushion">{{ $t('DESIGN ANOTHER CUSHION') }}
            </button>
        </div>
        -->
    <div v-if="popup.infoPopup" class="info-pop-up">
      <div class="pop-up-message">
        <button class="action-close" data-role="closeBtn" type="button" @click="closePopUp">
          <span>Close</span>
        </button>
        <div class="cushion-name-pop-up">
          {{ $t('Cushion 1') }}
        </div>
        <p class="message-body">
          {{ $t('Do you want to abandon changes to this cushion?') }}
        </p>
        <div class="pop-up-action-buttons">
          <button class="popup-action-yes" type="button" @click="abandonChanges">
            <span>{{ $t('Yes') }}</span>
          </button>
          <button class="popup-action-edit" type="button" @click="editThisCushion">
            <span>{{ $t('Edit current cushion') }}</span>
          </button>
        </div>
      </div>
    </div>
    <div style="display: none">
      <canvas id="2d-cushion-render" />
    </div>
  </div>
</template>

<script setup lang="ts">
import { computed, onMounted, ref } from 'vue'
import { useStore } from '../../stores/store'
import { usePopup } from '../../stores/popup'
import { storeToRefs } from 'pinia'
import { useElements } from '@/stores/elements'
import { IconArrowLeft } from '@/components/icons'

const updateState = ref(false)
const popup = usePopup()
const store = useStore()
const {
  shape,
  diameter_a_circle,
  length_b_rectangle,
  width_a_rectangle,
  buttonsDistribution,
  stitchesDistribution,
  topStitchesType,
  buttonsDistanceToEdge,
  stitchesDistanceToEdge,
  buttonsCols,
  buttonsRows,
  isStitches,
  isButtons,
  isButtonMiddle,
  name,
  fabrics,
  cushionBottom,
  thickness,
  cushion,
  edgeSewing,
  crossTopSewing,
  stitchesRows,
  stitchesCols,
  isJqueryAjaxEventAdded,
  quantity,
  renderProductImgName,
} = storeToRefs(store)
const elementsStore = useElements()
const { elements } = storeToRefs(elementsStore)
const fieldNamesMap = new Map([
  ['rectangle', 'Rectangle'],
  ['circle', 'Circle'],
  ['flat_cushion', 'Flat'],
  ['box_cushion', 'Box'],
  ['flat_edge', 'Flat'],
  ['double_edge', 'Double'],
  ['pipe_edge', 'Pipe'],
  ['buttons_yes', 'Yes'],
  ['buttons_no', 'No'],
  ['distribution_simple_split', 'With simple split'],
  ['distribution_fixed_distance', 'With fixed distance to the edge'],
  ['top_stitches_single', 'Single'],
  ['top_stitches_double', 'Double'],
  ['stitches_yes', 'Yes'],
  ['stitches_no', 'No'],
  ['reversible_cushion_bottom_type', 'Same material as top side'],
  ['anti_slip_cushion_bottom_type', 'Anti-slip on bottom'],
])

onMounted(() => {
  const dispatchChangeEvent = (el: HTMLInputElement | null) => {
    if (el) {
      el.checked = true
      el.dispatchEvent(new Event('change'))
    }
  }

  const dispatchValueChange = (el: HTMLInputElement | null, val: string) => {
    if (el) {
      el.value = val
      el.dispatchEvent(new Event('change'))
    }
  }

  const selectByDataSku = (sku: string) => {
    if (!sku) return
    const el = document.querySelector<HTMLInputElement>(`input[data-sku="${sku}"]`)
    dispatchChangeEvent(el)
  }

  const selectById = (id: string) => {
    if (!id) return
    const el = document.querySelector<HTMLInputElement>(`#${id}`)
    dispatchChangeEvent(el)
  }

  if (window.location.href.includes('checkout/cart/configure/id')) {
    updateState.value = true
  }

  price.value = window?.Itoris?.PriceFormula || JSON.parse(import.meta.env.VITE_PRICEFORMULA)
  const Elements = elements.value
  if (import.meta.env.DEV) {
    return
  }
  // Rectangle setup
  if (
    shape.value === 'rectangle' &&
    Elements.shape.rectangle &&
    Elements.width_a_rectangle &&
    Elements.length_b_rectangle
  ) {
    dispatchChangeEvent(Elements.shape.rectangle)
    dispatchValueChange(Elements.width_a_rectangle, width_a_rectangle.value)
    dispatchValueChange(Elements.length_b_rectangle, length_b_rectangle.value)
  }

  // Circle setup
  if (store.isCircle && Elements.shape.circle && Elements.diameter_a_circle) {
    dispatchChangeEvent(Elements.shape.circle)
    dispatchValueChange(Elements.diameter_a_circle, diameter_a_circle.value)
  }

  // Thickness
  selectByDataSku(`thick_${thickness.value}`)

  // Material
  selectById(fabrics?.value?.data?.id)

  // Sewing & finish options
  selectByDataSku(edgeSewing.value)
  if (crossTopSewing.value) selectByDataSku(crossTopSewing.value)
  selectByDataSku(cushionBottom.value)
  selectByDataSku(cushion.value)
  selectByDataSku(isStitches.value)
  selectByDataSku(isButtons.value)
  if (isButtonMiddle.value) selectByDataSku(isButtonMiddle.value)
  if (buttonsDistribution.value) selectByDataSku(buttonsDistribution.value)
  if (stitchesDistribution.value) selectByDataSku(stitchesDistribution.value)
  if (topStitchesType.value) selectByDataSku(topStitchesType.value)

  // Buttons layout
  if (
    isButtons.value === 'buttons_yes' &&
    Number(buttonsCols.value) > 0 &&
    Number(buttonsRows.value) > 0 &&
    Elements.buttonsCols &&
    Elements.buttonsRows
  ) {
    dispatchValueChange(Elements.buttonsCols, buttonsCols.value)
    dispatchValueChange(Elements.buttonsRows, buttonsRows.value)
  } else {
    if (Elements.buttonsCols) dispatchValueChange(Elements.buttonsCols, '')
    if (Elements.buttonsRows) dispatchValueChange(Elements.buttonsRows, '')
  }

  if (Elements.buttonsDistanceToEdge) {
    dispatchValueChange(
      Elements.buttonsDistanceToEdge,
      Number(buttonsDistanceToEdge.value) > 0 ? buttonsDistanceToEdge.value : '',
    )
  }

  // Stitches layout
  if (
    isStitches.value === 'stitches_yes' &&
    isButtons.value === 'buttons_no' &&
    Number(stitchesRows.value) > 0 &&
    Number(stitchesCols.value) > 0 &&
    Elements.stitchesRows &&
    Elements.stitchesCols
  ) {
    dispatchValueChange(Elements.stitchesCols, stitchesCols.value)
    dispatchValueChange(Elements.stitchesRows, stitchesRows.value)
  } else {
    if (Elements.stitchesRows) dispatchValueChange(Elements.stitchesRows, '')
    if (Elements.stitchesCols) dispatchValueChange(Elements.stitchesCols, '')
  }

  if (Elements.stitchesDistanceToEdge) {
    dispatchValueChange(
      Elements.stitchesDistanceToEdge,
      Number(stitchesDistanceToEdge.value) > 0 ? stitchesDistanceToEdge.value : '',
    )
  }

  // Render image fields
  const renderImageField = document.querySelector<HTMLInputElement>(
    'input[data-sku="2d_image_render"]',
  )
  if (renderImageField) renderImageField.value = getRenderImageIdentificator()

  const renderImageViewField = document.querySelector<HTMLInputElement>(
    'input[data-sku="2d_image_view_render"]',
  )
  if (renderImageViewField) renderImageViewField.value = renderProductImgName.value

  const qtyEl = document.querySelector<HTMLInputElement>('#qty')
  quantity.value = Number(qtyEl?.value)

  // jQuery add to cart hook
  if (!isJqueryAjaxEventAdded.value && window.jQuery) {
    window.jQuery(document).on('ajax:addToCart', () => {
      changeAddToCartStyle.value = true
      showAddToCartMessage.value = true
      addProceedToCheckout.value = true
      setTimeout(() => {
        showAddToCartMessage.value = false
      }, 3000)
    })
    isJqueryAjaxEventAdded.value = true
  }
})

const showAddToCartMessage = ref(false)
const changeAddToCartStyle = ref(false)
const addProceedToCheckout = ref(false)
const loading = ref(false)
const price = ref()

const priceWithVat = computed(() => {
  return window?._priceUtils?.formatPriceLocale(
    Number(price?.value?.finalPrice) *
      ((!price?.value?.priceFormulaTaxInfo?.priceAlreadyIncludesTax &&
        price.value?.priceFormulaTaxInfo?.displayPriceMode != 3) ||
      (price.value.priceFormulaTaxInfo?.priceAlreadyIncludesTax &&
        price.value.priceFormulaTaxInfo?.displayPriceMode != 2)
        ? 1 / Number(price?.value?.priceFormulaTaxInfo?.taxRate)
        : 1),
  )
})

const priceWithoutVat = computed(() => {
  return window?._priceUtils?.formatPriceLocale(
    Number(price?.value?.finalPrice) *
      (price.value.priceFormulaTaxInfo?.priceAlreadyIncludesTax &&
      price.value.priceFormulaTaxInfo?.displayPriceMode == 2
        ? 1 / Number(price?.value?.priceFormulaTaxInfo?.taxRate)
        : 1),
  )
})

const taxAmount = computed(() => {
  return window?._priceUtils?.formatPriceLocale(
    price.value?.priceFormulaTaxInfo?.priceAlreadyIncludesTax === 1
      ? price.value?.finalPrice -
          price.value?.finalPrice / Number(price?.value?.priceFormulaTaxInfo?.taxRate)
      : Number(price?.value?.finalPrice) * Number(price.value?.priceFormulaTaxInfo?.taxRate) -
          Number(price.value?.finalPrice),
  )
})

const shippingAmount = ref(null)

onMounted(async () => {
  try {
    const response = await fetch('/rest/V1/cushion/shipping/estimate')
    const result = await response.json()
    if (result !== null && result !== undefined) {
      shippingAmount.value = result
    }
  } catch (e) {
    console.error('Error fetching shipping cost:', e)
  }
})

const shippingCost = computed(() => {
  if (shippingAmount.value === null
    || shippingAmount.value === undefined
    || Array.isArray(shippingAmount.value)
  ) {
    return null
  }
  return window?._priceUtils?.formatPriceLocale(shippingAmount.value)
})

const grandTotal = computed(() => {
  const priceValue = priceWithVat.value
    ? Number(priceWithVat.value.replace(/[^\d]|\./g, ''))
    : 0
  const shippingValue = shippingCost.value
    ? Number(shippingCost.value.replace(/[^\d]|\./g, ''))
    : 0

  return window?._priceUtils?.formatPriceLocale(priceValue + shippingValue)
})

function processCheckoutClick() {
  window.location = window.checkout.checkoutUrl
}
function getRenderImageIdentificator() {
  const renderImageElements = {
    shape: shape.value,
    isButtons: isButtons.value,
    buttonsCols: buttonsCols.value,
    buttonsRows: buttonsRows.value,
    isButtonMiddle: isButtonMiddle.value,
    isStitches: isStitches.value,
    stitchesRows: stitchesRows.value,
    stitchesCols: stitchesCols.value,
    width_a_rectangle: '',
    length_b_rectangle: '',
    diameter_a_circle: '',
  }

  if (shape.value === 'rectangle') {
    renderImageElements.width_a_rectangle = width_a_rectangle.value
    renderImageElements.length_b_rectangle = length_b_rectangle.value
  }
  if (store.isCircle) {
    renderImageElements.diameter_a_circle = diameter_a_circle.value
  }

  let imageRenderIdentifier = ''
  for (const prop in renderImageElements) {
    //@ts-expect-error nevermind
    const item = renderImageElements[prop]
    if (item !== undefined && item !== '') {
      imageRenderIdentifier += prop + '=' + item + '+'
    }
  }

  return imageRenderIdentifier
}
function saveImageRender() {
  const imageRenderIdentifier = getRenderImageIdentificator()
  const cushionRender = document.getElementById('2d-cushion-render') as HTMLCanvasElement
  const imageRender = cushionRender?.toDataURL('image/png')
  if (window.jQuery) {
    window.jQuery.ajax({
      url: 'productattr/renderimage/create',
      type: 'POST',
      data: {
        identifier: imageRenderIdentifier,
        image: imageRender,
      },
      dataType: 'json',
      success: function (data) {
        console.log('SUCCESS: ', data)
      },
      error: function (data) {
        console.log('ERROR: ', data)
      },
    })
  }
}
function addToCart() {
  loading.value = true
  saveImageRender()
  setTimeout(() => {
    loading.value = false
  }, 300)
  const magentoAddToCartButton = document.querySelector<HTMLButtonElement>(
    '#product-addtocart-button',
  )
  if (magentoAddToCartButton) {
    magentoAddToCartButton.click()
    document.querySelector('header')?.scrollIntoView({ behavior: 'smooth' })
  } else {
    console.log('Magento add to cart button is not found')
  }
}
function updateCart() {
  const magentoUpdateCartButton = document.querySelector<HTMLButtonElement>(
    '#product-updatecart-button',
  )
  if (magentoUpdateCartButton) {
    magentoUpdateCartButton.click()
  } else {
    console.log('Magento update cart button is not found')
  }
}
// function changeQuantity(newQuantity: number) {
//   if (newQuantity <= 0) {
//     return
//   }
//   store.changeQuantity(newQuantity)
// }
function getMagentoFieldName(sku: string) {
  const element = document.querySelector('input[data-sku="' + sku + '"]')
  const datalabel = element?.getAttribute('data-label')

  return element && datalabel ? datalabel : (fieldNamesMap.get(sku) ?? sku)
}

// function getMagentoSizeLabel(sku: string) {
//   const element = document?.querySelector('input[data-sku="' + sku + '"]')
//   const label = document?.querySelector('label[for="' + element?.id + '"] span')?.innerHTML
//   return element && label ? label : sku
// }
// function designAnotherCushion() {
//   popup.infoPopup = true
// }
function closePopUp() {
  popup.infoPopup = false
}
function abandonChanges() {
  window.location.href = '/cushion.html'
}
function editThisCushion() {
  store.currentStep = 1
}
</script>

<style scoped>
.summary {
  background: hsla(0 0% 0% / 0.03);
  padding: 24px;
}

.active {
  background: #ecedec !important;
}

.next-button-wrapper {
  text-align: right;
}

.minus.disabled {
  opacity: 0.3;
}

.form-block-wrapper {
  position: relative;
}

.info-pop-up {
  background: rgba(255, 255, 255, 0.9);
  height: 100%;
  position: absolute;
  top: 0;
  width: 100%;
  left: 0;
}

.action-close {
  margin-right: 20px;
  background-image: none;
  background: none;
  box-sizing: content-box;
  border: 0;
  box-shadow: none;
  line-height: inherit;
  padding: 0;
  text-shadow: none;
  font-weight: 400;
  display: inline-block;
  text-decoration: none;
}

.action-close:before {
  -webkit-font-smoothing: antialiased;
  -moz-osx-font-smoothing: grayscale;
  font-size: 24px;
  line-height: 24px;
  color: #19374b;
  content: '\e616';
  font-family: 'luma-icons';
  margin: 0;
  vertical-align: top;
  display: inline-block;
  font-weight: normal;
  overflow: hidden;
  text-align: center;
}

.action-close span {
  border: 0;
  clip: rect(0, 0, 0, 0);
  height: 1px;
  margin: -1px;
  overflow: hidden;
  padding: 0;
  position: absolute;
  width: 1px;
}

.message-body {
  padding-left: 20px;
  font-size: 24px;
  color: #19374b;
  font-family: 'Mark OT', sans-serif;
  font-weight: 500;
  font-style: normal;
  margin-bottom: 30px;
}

.cushion-name-pop-up {
  margin-left: 20px;
  color: #82837e;
  font-size: 15px;
  font-family: 'Mark OT', sans-serif;
  font-weight: 500;
  font-style: normal;
  margin-top: 40px;
  margin-bottom: 20px;
}

.pop-up-message {
  background: #fff;
  position: absolute;
  bottom: 0;
  border-top: 2px solid #b4b5b2;
  padding: 40px 0 40px;
}

.pop-up-action-buttons {
  display: flex;
  margin-left: 20px;
  justify-content: space-between;
  margin-right: 20px;
}

.pop-up-action-buttons button {
  background: #19374b;
  color: #fff;
  padding: 5px 20px;
  font-family: 'Mark OT', sans-serif;
  font-size: 14px;
  font-weight: 500;
  border: none;
  cursor: pointer;
  text-transform: uppercase;
}

.add-to-cart-tip-wrapper {
  background: #00adef;
  margin-right: -20px;
  margin-left: -20px;
  color: #fff;
  display: flex;
  position: relative;
  padding: 20px;
  display: none;
}

.add-to-cart-tip-wrapper .tip-message {
  font-size: 15px;
  font-family: 'Mark OT', sans-serif;
  font-weight: 400;
  margin-bottom: 0;
}

.info-item {
  display: grid;
  grid-template-columns: repeat(2, 1fr);
  justify-content: space-between;
  column-gap: 2.5rem;
  width: 100%;
  flex-wrap: nowrap; /* Allow items to wrap to the next line */
}

.left-title {
  color: hsla(0 0% 0% / 0.6);
}

.right-value {
  font-weight: 600;
}

.loading {
  width: 20px;
  padding: 4px;
  aspect-ratio: 1;
  border-radius: 50%;
  background: #fff;
  --_m: conic-gradient(#0000 10%, #000), linear-gradient(#000 0 0) content-box;
  -webkit-mask: var(--_m);
  mask: var(--_m);
  -webkit-mask-composite: source-out;
  mask-composite: subtract;
  animation: l3 1s infinite linear;
}
@keyframes l3 {
  to {
    transform: rotate(1turn);
  }
}
</style>
